import { Link } from "react-router-dom";
import { navLinks, site } from "@/mocks/site";
import { categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-100">
      <div className="w-full px-4 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-emotion-happy-line w-6 h-6 flex items-center justify-center"></i>
              </span>
              <span className="font-hand text-3xl text-background-50">{site.name}</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 max-w-md">{site.describe}</p>
            <p className="mt-5 text-xs text-secondary-300">
              邮箱：<a href={`mailto:${site.email}`} className="text-accent-300 hover:text-accent-200">{site.email}</a>
            </p>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold text-background-50 mb-4">网站导航</h3>
            <ul className="space-y-2.5 text-sm">
              {navLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-secondary-200 hover:text-accent-300 transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold text-background-50 mb-4">热门瓜线</h3>
            <ul className="space-y-2.5 text-sm">
              {categories.slice(1, 6).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/hot?cat=${cat.id}`}
                    className="text-secondary-200 hover:text-accent-300 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-background-50 mb-4">围观宣言</h3>
            <p className="text-sm text-secondary-200 leading-relaxed">
              先看时间线，再聊观点；不追着人表态，也不放过任何一次反转。
            </p>
            <Link
              to="/chat"
              className="mt-5 inline-flex items-center gap-1.5 px-5 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap"
            >
              <i className="ri-chat-smile-3-line w-4 h-4 flex items-center justify-center"></i>
              进聊天室
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-secondary-700/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-300">
          <p>© {new Date().getFullYear()} {site.name} · {site.slogan}</p>
          <p>本站内容为娱乐话题整理与讨论，欢迎理性围观</p>
        </div>
      </div>
    </footer>
  );
}